<mat-card class="estilo" >
    <youtube-player playerVars="'origin':`${window.location.host}"
    host= "https://youtube.com/iframe_api/"
    videoId={{aulaselecionada.videoID}} width="100%" height="100%"></youtube-player>
</mat-card>
